module.exports = __webpack_public_path__ + "img/exploration.c2fdaef9.svg";